import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";

import { ChevronRight } from "@livechat/design-system-icons";
import {
  DesignToken,
  Icon,
  IconSource,
  RadiusToken,
  SpacingToken,
  Text,
  TransitionDurationToken,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface NextStepItemProps {
  icon: IconSource;
  title: string;
  description: string;
  onClick: VoidFunction;
}

export const NextStepItem: FC<NextStepItemProps> = ({ icon, title, description, onClick }) => (
  <Wrapper onClick={onClick} role="button" aria-label={title}>
    <IconWrapper>
      <Icon source={icon} />
    </IconWrapper>
    <Flex
      column
      marginRight="auto"
      css={css`
        text-align: start;
      `}
    >
      <Text bold>{title}</Text>
      <Text>{description}</Text>
    </Flex>
    <ChevronRightIcon source={ChevronRight} />
  </Wrapper>
);

const ChevronRightIcon = styled(Icon)`
  transition: transform ${withVar(TransitionDurationToken.Moderate1)} ease-in-out;
`;

const IconWrapper = styled(Flex)`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  border-radius: ${withVar(RadiusToken.Radius1)};
  height: 44px;
  width: 44px;
  transition: all ${withVar(TransitionDurationToken.Moderate1)};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing3)};

  padding: ${withVar(SpacingToken.Spacing4)};
  cursor: pointer;
  transition: all ${withVar(TransitionDurationToken.Moderate1)};

  &:hover {
    background-color: ${withVar(DesignToken.BtnBasicBackgroundHover)};

    ${IconWrapper} {
      background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
    }
    ${ChevronRightIcon} {
      transform: translateX(4px);
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  }
`;
